import React from "react";
import { Link } from "react-router-dom";
import {
  ShoppingCartSimple,
  Printer,
  Briefcase,
  Package,
} from "phosphor-react";

const cardsData = [
  {
    id: 1,
    icon: <Printer size={40} color="#3446b8" weight="fill" />,
    title: "Perfect for Every Family",
    description:
      "Discover affordable printers that make everyday tasks simple — from homework and creative projects to photo prints. At Printing Dealz, we offer reliable, budget-friendly options that deliver impressive results for every family.",
    buttonText: "Shop Printers Now",
    buttonLink: "/shop",
  },
  {
    id: 2,
    icon: <Briefcase size={40} color="#1976d2" weight="fill" />,
    title: "Built for Business Performance",
    description:
      "When deadlines matter and reliability is key, Printing Dealz brings you powerful printers built for nonstop productivity. These dependable machines handle heavy workloads effortlessly while keeping your operations smooth.",
    buttonText: "Explore Business Printers",
    buttonLink: "/shop",
  },
  {
    id: 3,
    icon: <Package size={40} color="#388e3c" weight="fill" />,
    title: "Everything You Need in One Place",
    description:
      "At Printing Dealz, you’ll find ink, paper, and all your essential office supplies together — ready to ship fast. Enjoy seamless printing with everything delivered straight to your door.",
    buttonText: "Shop Supplies",
    buttonLink: "/shop",
  },
];

const PromotionalTwo = () => {
  return (
    <section
      style={{
        padding: "80px 0",
        background: "linear-gradient(180deg, #ffffff, #f8f9fa)",
      }}
    >
      <div className="container text-center">
        <h4
          style={{
            fontSize: "32px",
            fontWeight: "700",
            marginBottom: "15px",
            color: "#222",
          }}
        >
          Why Choose <span style={{ color: "#3446b8" }}>Printing Dealz</span>{" "}
          for Your Printing Needs?
        </h4>
        <p
          style={{
            color: "#555",
            fontSize: "16px",
            maxWidth: "850px",
            margin: "0 auto 50px",
            lineHeight: "1.7",
          }}
        >
          Every home and business has unique printing requirements — and at
          Printing Dealz, we’ve got you covered. From compact home inkjets to
          high-performance laser printers, we offer complete solutions that
          match your workflow and budget.
        </p>

        <div className="row justify-content-center g-4">
          {cardsData.map((card) => (
            <div className="col-md-4" key={card.id}>
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "35px 25px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                  height: "100%",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 25px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 15px rgba(0,0,0,0.08)";
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    background: "#f5f5f5",
                    borderRadius: "50%",
                    padding: "15px",
                    marginBottom: "15px",
                  }}
                >
                  {card.icon}
                </div>
                <h4
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: "#222",
                  }}
                >
                  {card.title}
                </h4>
                <p
                  style={{
                    color: "#555",
                    fontSize: "14px",
                    lineHeight: "1.6",
                    marginBottom: "20px",
                  }}
                >
                  {card.description}
                </p>
                <Link
                  to={card.buttonLink}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    background: "#3446b8",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: "25px",
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "background 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.background = "#3446b8")}
                  onMouseLeave={(e) => (e.target.style.background = "#3446b8")}
                >
                  {card.buttonText}
                  <ShoppingCartSimple size={18} weight="bold" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalTwo;
